import { render, staticRenderFns } from "./AdditionalWebinar.vue?vue&type=template&id=e4c263a4&"
import script from "./AdditionalWebinar.vue?vue&type=script&lang=js&"
export * from "./AdditionalWebinar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports